import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { journalApi } from '@/lib/api/client';

type JournalCursor = { before: number; beforeId: string } | null;

export const journalKeys = {
  feed: (scope: { symbol?: string; chainId?: string }) =>
    ['journal', scope.symbol ?? null, scope.chainId ?? null] as const,
};

export function useJournalFeed(scope: { symbol?: string; chainId?: string }) {
  return useInfiniteQuery({
    queryKey: journalKeys.feed(scope),
    queryFn: ({ pageParam }: { pageParam: JournalCursor }) =>
      journalApi.list({
        ...scope,
        before: pageParam?.before,
        beforeId: pageParam?.beforeId,
        limit: 25,
      }),
    initialPageParam: null as JournalCursor,
    getNextPageParam: (last) => last.nextCursor,
  });
}

export function useSaveNote() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, note }: { id: string; note: string | null }) => journalApi.addNote(id, note),
    // Broad invalidation (not scope-specific): an entry can be visible in more
    // than one feed at once (e.g. a symbol-scoped and a chain-scoped feed both
    // showing the same event), so invalidate every journal query by prefix.
    onSuccess: () => qc.invalidateQueries({ queryKey: ['journal'] }),
  });
}
